import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import _ from 'lodash';

import { eventsEntityActions } from 'containers/App/modules/entities/events/eventsEntity.slice';
import {
	createResetGridDataAction,
	createResetGridReducer,
	createSetGridParamsAction,
	createSetGridParamsReducer,
	createUpdateGridReducer,
	GRID_INITIAL_STATE,
} from 'containers/Grid/grid.utils';

const STATE_KEY = 'events';
const GRID_STATE_KEY = 'eventsGrid';

const setGridParams = createSetGridParamsAction(GRID_STATE_KEY);
const resetGridData = createResetGridDataAction(GRID_STATE_KEY);

export const INITIAL_STATE = {
	[GRID_STATE_KEY]: GRID_INITIAL_STATE,
};

const slice = createSlice({
	name: STATE_KEY,
	initialState: INITIAL_STATE,
	reducers: {},
	extraReducers: {
		[eventsEntityActions.fetchEventsSuccess]: createUpdateGridReducer(GRID_STATE_KEY),
		[setGridParams]: createSetGridParamsReducer(GRID_STATE_KEY),
		[resetGridData]: createResetGridReducer(GRID_STATE_KEY),
	},
});

const getState = (state) => state[STATE_KEY] || INITIAL_STATE;

const selectEventsGrid = createSelector(
	getState,
	(state) => state[GRID_STATE_KEY]
);

const selectEventIdsForPage = (state) => {
	const gridState = selectEventsGrid(state);
	const pageNumber = _.get(gridState, 'params.pagination.current');
	return gridState.pages?.[pageNumber];
};

export const eventsSelectors = {
	selectEventsGrid,
	selectEventIdsForPage,
};

export const eventsActions = {
	setGridParams,
	resetGridData,
};

export default slice.reducer;
